import {Component, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {CustomUserService} from '../../services/custom-user.service';
import {formatDate} from '@angular/common';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {User} from '../../models/user';

@Component({
  selector: 'app-acknowledged-domain-confirmation',
  templateUrl: './acknowledged-domain-confirmation.component.html',
  styleUrls: ['./acknowledged-domain-confirmation.component.scss']
})
export class AcknowledgedDomainConfirmationComponent implements OnInit {

  confirmationForm: UntypedFormGroup;
  isFormSubmitted = false;

  constructor(
    private customUserService: CustomUserService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
  ) {
  }

  loggedInUser: User;
  newUser: User;

  ngOnInit() {
    this.initLocalVars();
    this.createConfirmationForm();
  }

  private initLocalVars() {
    this.loggedInUser = this.config.data['loggedInUser'];
    this.newUser = this.config.data['newUser'];
  }

  private createConfirmationForm() {
    this.confirmationForm = new UntypedFormGroup({
      newUserName: new UntypedFormControl({value: this.newUser.name, disabled: true}, Validators.required),
      newUserTitle: new UntypedFormControl(''),
      thirdPartyCompanyName: new UntypedFormControl('', Validators.required),
      signedBy: new UntypedFormControl(this.loggedInUser.name, Validators.required),
      dateSigned: new UntypedFormControl({value: this.dateSigned, disabled: true}, Validators.required),
      email: new UntypedFormControl({value: this.loggedInUser.email, disabled: true}, Validators.required),
      ipAddress: new UntypedFormControl({value: '', disabled: true}, Validators.required),
    });
    this.getClientIp();
  }

  get dateSigned() {
    return formatDate(new Date(), 'dd/MM/yyyy', 'en-US');
  }

  getClientIp() {
    this.customUserService.getClientIp().subscribe(res => {
      this.confirmationForm.get('ipAddress').setValue(res[0]);
    });
  }

  onSubmit() {
    this.isFormSubmitted = true;
    if (this.confirmationForm.valid) {
      this.ref.close(this.confirmationForm.getRawValue());
    }
  }

  closePopUp() {
    this.ref.close();
  }
}
